<div class="bar-chart-container" [style.height.px]="height">
  <canvas #canvas></canvas>
</div>
